<template>
    <div>
        <div class="pt-2 mx-8">
            <!-- 删除记录区域 -->
            <div class="collapse bg-base-100 mb-8" v-if="detailData.delete.length > 0">
                <input type="checkbox" v-model="isDelete" />
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('删除记录') }}</div>
                        <div class="badge badge-success gap-2 ml-2">
                            {{ detailData.delete_count }}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-sm text-base-content/70">
                            <i class="fas fa-check-circle mr-1"></i>
                            {{ $tt('以下文件已被成功删除，操作不可撤销') }}
                        </div>

                    </div>

                    <div class="space-y-2">
                        <div v-for="(item, index) in detailData.delete" :key="'deleted' + index"
                            class="card bg-base-100 border border-base-300">
                            <div class="card-body p-3">
                                <div class="flex items-center justify-between mb-2">
                                    <h3 class="card-title text-base">{{ item.name }}</h3>
                                    <div class="badge badge-success text-primary-content text-xs">{{ $tt('已删除') }}</div>
                                </div>

                                <div class="bg-error/10 p-2 rounded-lg">
                                    <div class="flex items-center justify-between mb-1">
                                        <h4 class="font-semibold text-error text-sm">{{ $tt('删除信息') }}</h4>
                                        <span class="text-xs text-base-content/60">#{{ index + 1 }}</span>
                                    </div>
                                    <div class="text-sm text-base-content mb-1">
                                        <div class="flex items-center mb-0.5">
                                            <i class="fas fa-folder mr-1 text-base-content/60"></i>
                                            <span class="font-medium text-xs">{{ $tt('原路径：') }}</span>
                                        </div>
                                        <div class="truncate ml-4 text-base-content/70 text-xs" :title="item.path">
                                            {{ item.path }}
                                        </div>
                                    </div>
                                    <div class="text-sm text-base-content">
                                        <div class="flex items-center mb-0.5">
                                            <i class="fas fa-exclamation-triangle mr-1 text-error"></i>
                                            <span class="font-medium text-xs">{{ $tt('删除原因：') }}</span>
                                        </div>
                                        <div class="ml-4 text-base-content/70 text-xs">
                                            {{ item.reason }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 文件hash重复区域 -->
            <div class="collapse bg-base-100 mb-8" v-if="detailData.mode_success.length > 0">
                <input type="checkbox" v-model="isModeSuccess" />
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('文件hash重复 (完全相同的文件)') }}</div>
                        <div class="badge badge-warning gap-2 ml-2">
                            {{ detailData.mode_success_count }}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-sm text-base-content/70">
                            <i class="fas fa-info-circle mr-1"></i>
                            {{ $tt('这些文件内容完全相同,建议保留其中一个即可') }}
                        </div>
                        <div class="flex gap-2 items-center">
                            <button class="btn btn-primary btn-sm" @click="handleRuleDelete('hash')">{{ $tt('智能删除') }}</button>
                            <button class="btn btn-outline btn-sm btn-primary" @click="toggleBatchSelectFiles('hash', 'A')"
                                :class="{ 'btn-active': isBatchSelectedA('hash') }">{{ $tt('批量选择文件A') }}</button>
                            <button class="btn btn-outline btn-sm btn-neutral"
                                @click="toggleBatchSelectFiles('hash', 'B')"
                                :class="{ 'btn-active': isBatchSelectedB('hash') }">{{ $tt('批量选择文件B') }}</button>
                            <button v-if="getBatchSelectedCount('hash') > 0"
                                class="btn btn-error btn-sm btn-outline"
                                @click="confirmBatchDelete('hash')">
                                <i class="fas fa-trash mr-1"></i>{{ $tt('删除 {count} 项', { count: getBatchSelectedCount('hash') }) }}
                            </button>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <div v-for="(item, index) in detailData.mode_success" :key="'hash' + index"
                            class="card bg-base-100 border border-base-300 shadow-sm hover:shadow-md transition-shadow duration-300">
                            <div class="card-body p-3">
                                <div class="flex items-center justify-between mb-2">
                                    <h3 class="card-title text-lg font-bold text-base-content flex items-center">
                                        <i class="fas fa-file-audio mr-2 text-primary"></i>
                                        #{{ index + 1 }} {{ item.name }}
                                    </h3>
                                    <div class="badge badge-ghost px-2 py-1 text-xs font-semibold">{{ $tt('完全相同') }}</div>
                                </div>

                                <div class="grid md:grid-cols-2 gap-3">
                                    <!-- 文件A -->
                                    <div class="relative bg-gradient-to-br from-primary/0 to-primary/5 p-3 rounded-lg border border-primary/5 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer" 
                                         @click="toggleFileSelection(item.path)"
                                         :class="{ 'ring-1 ring-primary': selectedFiles.includes(item.path) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedFiles.includes(item.path)"
                                                @change="toggleFileSelection(item.path)" class="checkbox checkbox-sm checkbox-primary">
                                        </div>
                                        <div class="flex items-center mb-2">
                                            <div class="w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-2 shadow-md">
                                                <i class="fas fa-music text-primary-content text-xs"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-primary text-base mb-0">{{ $tt('文件 A') }}</h4>
                                                <div class="bg-primary/20 text-primary px-1.5 py-0.5 rounded text-xs font-medium inline-block">{{ $tt('原始文件') }}</div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-2 rounded-lg mb-2 border border-primary/30">
                                            <div class="flex items-center mb-1">
                                                <i class="fas fa-folder text-primary mr-1"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('文件路径') }}</span>
                                            </div>
                                            <div class="text-xs text-base-content font-mono bg-base-200 p-1.5 rounded border truncate" :title="item.path">
                                                {{ getShortPath(item.path) }}
                                            </div>
                                        </div>

                                        <div class="space-y-1 mb-3">
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-primary"></i>{{ $tt('文件名') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.name }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-plus mr-1 text-primary"></i>{{ $tt('创建时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.created_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-edit mr-1 text-primary"></i>{{ $tt('修改时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.updated_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-hdd mr-1 text-primary"></i>{{ $tt('文件大小') }}</span>
                                                <span class="text-xs text-base-content font-bold bg-primary/20 px-1.5 py-0.5 rounded">
                                                    {{ (item.extra.a.size / 1024 / 1024).toFixed(2) }} MB
                                                </span>
                                            </div>
                                        </div>

                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-primary btn-xs btn-outline hover:bg-primary-500 hover:text-primary-content transition-all duration-200"
                                                @click="confirmSingleDelete(item.path, item.name, 'A')">{{ $tt('删除此文件') }}</button>
                                        </div>
                                    </div>

                                    <!-- 文件B -->
                                    <div class="relative bg-gradient-to-br from-neutral/0 to-neutral/5 p-3 rounded-lg border border-neutral/5 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer" 
                                         @click="toggleFileSelection(item.reason)"
                                         :class="{ 'ring-1 ring-neutral': selectedFiles.includes(item.reason) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedFiles.includes(item.reason)"
                                                @change="toggleFileSelection(item.reason)" class="checkbox checkbox-sm checkbox-neutral">
                                        </div>
                                        <div class="flex items-center mb-2">
                                            <div class="w-8 h-8 bg-neutral rounded-full flex items-center justify-center mr-2 shadow-md">
                                                <i class="fas fa-music text-primary-content text-xs"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-neutral-content text-base mb-0">{{ $tt('文件 B') }}</h4>
                                                <div class="bg-neutral/5 text-neutral-content px-1.5 py-0.5 rounded text-xs font-medium inline-block">{{ $tt('重复文件') }}</div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-2 rounded-lg mb-2 border border-neutral/30">
                                            <div class="flex items-center mb-1">
                                                <i class="fas fa-folder text-neutral mr-1"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('文件路径') }}</span>
                                            </div>
                                            <div class="text-xs text-base-content font-mono bg-base-200 p-1.5 rounded border truncate" :title="item.reason">
                                                {{ getShortPath(item.reason) }}
                                            </div>
                                        </div>

                                        <div class="space-y-1 mb-3">
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-neutral"></i>{{ $tt('文件名') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.name }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-plus mr-1 text-neutral"></i>{{ $tt('创建时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.created_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-edit mr-1 text-neutral"></i>{{ $tt('修改时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.updated_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-hdd mr-1 text-neutral"></i>{{ $tt('文件大小') }}</span>
                                                <span class="text-xs text-base-content font-bold bg-neutral/20 px-1.5 py-0.5 rounded">
                                                    {{ (item.extra.b.size / 1024 / 1024).toFixed(2) }} MB
                                                </span>
                                            </div>
                                        </div>

                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-neutral btn-xs btn-outline hover:bg-neutral-500 hover:text-neutral-content transition-all duration-200"
                                                @click="confirmSingleDelete(item.reason, item.name, 'B')">{{ $tt('删除此文件') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 文件名称重复区域 -->
            <div class="collapse bg-base-100 mb-8" v-if="detailData.success.length > 0">
                <input type="checkbox" v-model="isSuccess" />
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('文件名称重复 (可能不同版本)') }}</div>
                        <div class="badge badge-warning gap-2 ml-2">
                            {{ detailData.success_count }}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-sm text-base-content/70">
                            <i class="fas fa-exclamation-triangle mr-1"></i>
                            {{ $tt('这些文件名称相同但内容可能不同,请仔细对比后再删除') }}
                        </div>
                        <div class="flex gap-2 items-center">
                            <button class="btn btn-primary btn-sm" @click="handleRuleDelete('name')">{{ $tt('智能删除') }}</button>
                            <button class="btn btn-outline btn-sm btn-primary" @click="toggleBatchSelectFiles('name', 'A')"
                                :class="{ 'btn-active': isBatchSelectedA('name') }">{{ $tt('批量选择文件A') }}</button>
                            <button class="btn btn-outline btn-sm btn-neutral"
                                @click="toggleBatchSelectFiles('name', 'B')"
                                :class="{ 'btn-active': isBatchSelectedB('name') }">{{ $tt('批量选择文件B') }}</button>
                            <button v-if="getBatchSelectedCount('name') > 0"
                                class="btn btn-error btn-sm btn-outline"
                                @click="confirmBatchDelete('name')">
                                <i class="fas fa-trash mr-1"></i>{{ $tt('删除 {count} 项', { count: getBatchSelectedCount('name') }) }}
                            </button>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <div v-for="(item, index) in detailData.success" :key="'name' + index"
                            class="card bg-base-100 border border-base-300 shadow-sm hover:shadow-md transition-shadow duration-300">
                            <div class="card-body p-3">
                                <div class="flex items-center justify-between mb-2">
                                    <h3 class="card-title text-lg font-bold text-base-content flex items-center">
                                        <i class="fas fa-file-signature mr-2 text-orange-500"></i>
                                        #{{ index + 1 }} {{ item.name }}
                                    </h3>
                                    <div class="badge badge-ghost px-2 py-1 text-xs font-semibold">{{ $tt('名称重复') }}</div>
                                </div>

                                <div class="grid md:grid-cols-2 gap-3">
                                    <!-- 文件A -->
                                    <div class="relative bg-gradient-to-br from-primary/0 to-primary/5 p-3 rounded-lg border border-primary/5 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer" 
                                         @click="toggleFileSelection(item.path)"
                                         :class="{ 'ring-1 ring-primary': selectedFiles.includes(item.path) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedFiles.includes(item.path)"
                                                @change="toggleFileSelection(item.path)" class="checkbox checkbox-sm checkbox-primary">
                                        </div>
                                        <div class="flex items-center mb-2">
                                            <div class="w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-2 shadow-md">
                                                <i class="fas fa-music text-primary-content text-xs"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-primary text-base mb-0">{{ $tt('文件 A') }}</h4>
                                                <div class="bg-primary/20 text-primary px-1.5 py-0.5 rounded text-xs font-medium inline-block">{{ $tt('原始文件') }}</div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-2 rounded-lg mb-2 border border-primary/30">
                                            <div class="flex items-center mb-1">
                                                <i class="fas fa-folder text-primary mr-1"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('文件路径') }}</span>
                                            </div>
                                            <div class="text-xs text-base-content font-mono bg-base-200 p-1.5 rounded border truncate" :title="item.path">
                                                {{ getShortPath(item.path) }}
                                            </div>
                                        </div>

                                        <div class="space-y-1 mb-3">
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-primary"></i>{{ $tt('文件名') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.name }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-plus mr-1 text-primary"></i>{{ $tt('创建时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.created_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-edit mr-1 text-primary"></i>{{ $tt('修改时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.updated_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-hdd mr-1 text-primary"></i>{{ $tt('文件大小') }}</span>
                                                <span class="text-xs text-base-content font-bold bg-primary/20 px-1.5 py-0.5 rounded">
                                                    {{ (item.extra.a.size / 1024 / 1024).toFixed(2) }} MB
                                                </span>
                                            </div>
                                        </div>

                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-primary btn-xs btn-outline hover:bg-primary-500 hover:text-primary-content transition-all duration-200"
                                                @click="confirmSingleDelete(item.path, item.name, 'A')">{{ $tt('删除此文件') }}</button>
                                        </div>
                                    </div>

                                    <!-- 文件B -->
                                    <div class="relative bg-gradient-to-br from-neutral/0 to-neutral/5 p-3 rounded-lg border border-neutral/5 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer" 
                                         @click="toggleFileSelection(item.reason)"
                                         :class="{ 'ring-1 ring-neutral': selectedFiles.includes(item.reason) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedFiles.includes(item.reason)"
                                                @change="toggleFileSelection(item.reason)" class="checkbox checkbox-sm checkbox-neutral">
                                        </div>
                                        <div class="flex items-center mb-2">
                                            <div class="w-8 h-8 bg-neutral rounded-full flex items-center justify-center mr-2 shadow-md">
                                                <i class="fas fa-music text-primary-content text-xs"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-neutral-content text-base mb-0">{{ $tt('文件 B') }}</h4>
                                                <div class="bg-neutral/5 text-neutral-content px-1.5 py-0.5 rounded text-xs font-medium inline-block">{{ $tt('重名文件') }}</div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-2 rounded-lg mb-2 border border-neutral/30">
                                            <div class="flex items-center mb-1">
                                                <i class="fas fa-folder text-neutral mr-1"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('文件路径') }}</span>
                                            </div>
                                            <div class="text-xs text-base-content font-mono bg-base-200 p-1.5 rounded border truncate" :title="item.reason">
                                                {{ getShortPath(item.reason) }}
                                            </div>
                                        </div>

                                        <div class="space-y-1 mb-3">
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-neutral"></i>{{ $tt('文件名') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.name }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-plus mr-1 text-neutral"></i>{{ $tt('创建时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.created_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-edit mr-1 text-neutral"></i>{{ $tt('修改时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.updated_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-hdd mr-1 text-neutral"></i>{{ $tt('文件大小') }}</span>
                                                <span class="text-xs text-base-content font-bold bg-neutral/20 px-1.5 py-0.5 rounded">
                                                    {{ (item.extra.b.size / 1024 / 1024).toFixed(2) }} MB
                                                </span>
                                            </div>
                                        </div>

                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-neutral btn-xs btn-outline hover:bg-neutral-500 hover:text-neutral-content transition-all duration-200"
                                                @click="confirmSingleDelete(item.reason, item.name, 'B')">{{ $tt('删除此文件') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 声纹重复区域 -->
            <div class="collapse bg-base-100 mb-8" v-if="detailData.miss_tag.length > 0">
                <input type="checkbox" v-model="isMissTag" />
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('声纹重复 (音频内容相同)') }}</div>
                        <div class="badge badge-warning gap-2 ml-2">
                            {{ detailData.miss_tag_count }}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-sm text-base-content/70">
                            <i class="fas fa-music mr-1"></i>
                            {{ $tt('这些文件的音频内容相同,但可能是不同格式或质量的版本') }}
                        </div>
                        <div class="flex gap-2 items-center">
                            <button class="btn btn-primary btn-sm" @click="handleRuleDelete('acoustid')">{{ $tt('智能删除') }}</button>
                            <button class="btn btn-outline btn-sm btn-primary"
                                @click="toggleBatchSelectFiles('acoustid', 'A')"
                                :class="{ 'btn-active': isBatchSelectedA('acoustid') }">{{ $tt('批量选择文件A') }}</button>
                            <button class="btn btn-outline btn-sm btn-neutral"
                                @click="toggleBatchSelectFiles('acoustid', 'B')"
                                :class="{ 'btn-active': isBatchSelectedB('acoustid') }">{{ $tt('批量选择文件B') }}</button>
                            <button v-if="getBatchSelectedCount('acoustid') > 0"
                                class="btn btn-error btn-sm btn-outline"
                                @click="confirmBatchDelete('acoustid')">
                                <i class="fas fa-trash mr-1"></i>{{ $tt('删除 {count} 项', { count: getBatchSelectedCount('acoustid') }) }}
                            </button>
                        </div>
                    </div>

                    <div class="space-y-2">
                        <div v-for="(item, index) in detailData.miss_tag" :key="'acoustid' + index"
                            class="card bg-base-100 border border-base-300 shadow-lg hover:shadow-xl transition-shadow duration-300">
                            <div class="card-body p-6">
                                <div class="flex items-center justify-between mb-4">
                                    <h3 class="card-title text-xl font-bold text-base-content flex items-center">
                                        <i class="fas fa-waveform-lines mr-3 text-purple-500"></i>
                                        #{{ index + 1 }} {{ item.name }}
                                    </h3>
                                    <div class="badge badge-ghost px-3 py-2 text-sm font-semibold">{{ $tt('声纹相同') }}</div>
                                </div>

                                <div class="grid md:grid-cols-2 gap-6">
                                    <!-- 文件A -->
                                    <div class="relative bg-gradient-to-br from-primary/0 to-primary/5 p-3 rounded-lg border border-primary/5 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer" 
                                         @click="toggleFileSelection(item.path)"
                                         :class="{ 'ring-1 ring-primary': selectedFiles.includes(item.path) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedFiles.includes(item.path)"
                                                @change="toggleFileSelection(item.path)" class="checkbox checkbox-sm checkbox-primary">
                                        </div>
                                        <div class="flex items-center mb-2">
                                            <div class="w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-2 shadow-md">
                                                <i class="fas fa-music text-primary-content text-xs"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-primary text-base mb-0">{{ $tt('文件 A') }}</h4>
                                                <div class="bg-primary/20 text-primary px-1.5 py-0.5 rounded text-xs font-medium inline-block">{{ $tt('原始文件') }}</div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-2 rounded-lg mb-2 border border-primary/30">
                                            <div class="flex items-center mb-1">
                                                <i class="fas fa-folder text-primary mr-1"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('文件路径') }}</span>
                                            </div>
                                            <div class="text-xs text-base-content font-mono bg-base-200 p-1.5 rounded border truncate" :title="item.path">
                                                {{ getShortPath(item.path) }}
                                            </div>
                                        </div>

                                        <div class="space-y-1 mb-3">
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-primary"></i>{{ $tt('文件名') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.name }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-plus mr-1 text-primary"></i>{{ $tt('创建时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.created_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-edit mr-1 text-primary"></i>{{ $tt('修改时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.updated_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-hdd mr-1 text-primary"></i>{{ $tt('文件大小') }}</span>
                                                <span class="text-xs text-base-content font-bold bg-primary/20 px-1.5 py-0.5 rounded">
                                                    {{ (item.extra.a.size / 1024 / 1024).toFixed(2) }} MB
                                                </span>
                                            </div>
                                        </div>

                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-primary btn-xs btn-outline hover:bg-primary-500 hover:text-primary-content transition-all duration-200"
                                                @click="confirmSingleDelete(item.path, item.name, 'A')">{{ $tt('删除此文件') }}</button>
                                        </div>
                                    </div>

                                    <!-- 文件B -->
                                    <div class="relative bg-gradient-to-br from-neutral/0 to-neutral/5 p-3 rounded-lg border border-neutral/5 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer" 
                                         @click="toggleFileSelection(item.reason)"
                                         :class="{ 'ring-1 ring-neutral': selectedFiles.includes(item.reason) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedFiles.includes(item.reason)"
                                                @change="toggleFileSelection(item.reason)" class="checkbox checkbox-sm checkbox-neutral">
                                        </div>
                                        <div class="flex items-center mb-2">
                                            <div class="w-8 h-8 bg-neutral rounded-full flex items-center justify-center mr-2 shadow-md">
                                                <i class="fas fa-music text-primary-content text-xs"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-neutral-content text-base mb-0">{{ $tt('文件 B') }}</h4>
                                                <div class="bg-neutral/5 text-neutral-content px-1.5 py-0.5 rounded text-xs font-medium inline-block">{{ $tt('声纹相同') }}</div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-2 rounded-lg mb-2 border border-neutral/30">
                                            <div class="flex items-center mb-1">
                                                <i class="fas fa-folder text-neutral mr-1"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('文件路径') }}</span>
                                            </div>
                                            <div class="text-xs text-base-content font-mono bg-base-200 p-1.5 rounded border truncate" :title="item.reason">
                                                {{ getShortPath(item.reason) }}
                                            </div>
                                        </div>

                                        <div class="space-y-1 mb-3">
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-neutral"></i>{{ $tt('文件名') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.name }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-plus mr-1 text-neutral"></i>{{ $tt('创建时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.created_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-edit mr-1 text-neutral"></i>{{ $tt('修改时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.updated_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-hdd mr-1 text-neutral"></i>{{ $tt('文件大小') }}</span>
                                                <span class="text-xs text-base-content font-bold bg-neutral/20 px-1.5 py-0.5 rounded">
                                                    {{ (item.extra.b.size / 1024 / 1024).toFixed(2) }} MB
                                                </span>
                                            </div>
                                        </div>

                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-neutral btn-xs btn-outline hover:bg-neutral-500 hover:text-neutral-content transition-all duration-200"
                                                @click="confirmSingleDelete(item.reason, item.name, 'B')">{{ $tt('删除此文件') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 元数据重复区域 -->
            <div class="collapse bg-base-100 mb-8" v-if="detailData.fail.length > 0">
                <input type="checkbox" v-model="isFail" />
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('元数据重复 (标题艺术家相同)') }}</div>
                        <div class="badge badge-warning gap-2 ml-2">
                            {{ detailData.fail_count }}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-sm text-base-content/70">
                            <i class="fas fa-music mr-1"></i>
                            {{ $tt('这些文件的标题艺术家相同,但可能是不同专辑的版本') }}
                        </div>
                        <div class="flex gap-2 items-center">
                            <button class="btn btn-primary btn-sm" @click="handleRuleDelete('metadata')">{{ $tt('智能删除') }}</button>
                            <button class="btn btn-outline btn-sm btn-primary"
                                @click="toggleBatchSelectFiles('metadata', 'A')"
                                :class="{ 'btn-active': isBatchSelectedA('metadata') }">{{ $tt('批量选择文件A') }}</button>
                            <button class="btn btn-outline btn-sm btn-neutral"
                                @click="toggleBatchSelectFiles('metadata', 'B')"
                                :class="{ 'btn-active': isBatchSelectedB('metadata') }">{{ $tt('批量选择文件B') }}</button>
                            <button v-if="getBatchSelectedCount('metadata') > 0"
                                class="btn btn-error btn-sm btn-outline"
                                @click="confirmBatchDelete('metadata')">
                                <i class="fas fa-trash mr-1"></i>{{ $tt('删除 {count} 项', { count: getBatchSelectedCount('metadata') }) }}
                            </button>
                        </div>
                    </div>

                    <div class="space-y-2">
                        <div v-for="(item, index) in detailData.fail" :key="'metadata' + index"
                            class="card bg-base-100 border border-base-300 shadow-lg hover:shadow-xl transition-shadow duration-300">
                            <div class="card-body p-6">
                                <div class="flex items-center justify-between mb-4">
                                    <h3 class="card-title text-xl font-bold text-base-content flex items-center">
                                        <i class="fas fa-waveform-lines mr-3 text-purple-500"></i>
                                        #{{ index + 1 }} {{ item.name }}
                                    </h3>
                                    <div class="badge badge-ghost px-3 py-2 text-sm font-semibold">{{ $tt('元数据相同') }}</div>
                                </div>

                                <div class="grid md:grid-cols-2 gap-6">
                                    <!-- 文件A -->
                                    <div class="relative bg-gradient-to-br from-primary/0 to-primary/5 p-3 rounded-lg border border-primary/5 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer" 
                                         @click="toggleFileSelection(item.path)"
                                         :class="{ 'ring-1 ring-primary': selectedFiles.includes(item.path) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedFiles.includes(item.path)"
                                                @change="toggleFileSelection(item.path)" class="checkbox checkbox-sm checkbox-primary">
                                        </div>
                                        <div class="flex items-center mb-2">
                                            <div class="w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-2 shadow-md">
                                                <i class="fas fa-music text-primary-content text-xs"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-primary text-base mb-0">{{ $tt('文件 A') }}</h4>
                                                <div class="bg-primary/20 text-primary px-1.5 py-0.5 rounded text-xs font-medium inline-block">{{ $tt('原始文件') }}</div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-2 rounded-lg mb-2 border border-primary/30">
                                            <div class="flex items-center mb-1">
                                                <i class="fas fa-folder text-primary mr-1"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('文件路径') }}</span>
                                            </div>
                                            <div class="text-xs text-base-content font-mono bg-base-200 p-1.5 rounded border truncate" :title="item.path">
                                                {{ getShortPath(item.path) }}
                                            </div>
                                        </div>

                                        <div class="space-y-1 mb-3">
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-primary"></i>{{ $tt('标题') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.title }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-1" v-if="item.extra.a.artist">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-primary"></i>{{ $tt('艺术家') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.artist }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-1" v-if="item.extra.a.album">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-primary"></i>{{ $tt('专辑') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.album }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-plus mr-1 text-primary"></i>{{ $tt('创建时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.created_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-edit mr-1 text-primary"></i>{{ $tt('修改时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.a.updated_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-hdd mr-1 text-primary"></i>{{ $tt('文件大小') }}</span>
                                                <span class="text-xs text-base-content font-bold bg-primary/20 px-1.5 py-0.5 rounded">
                                                    {{ (item.extra.a.size / 1024 / 1024).toFixed(2) }} MB
                                                </span>
                                            </div>
                                        </div>

                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-primary btn-xs btn-outline hover:bg-primary-500 hover:text-primary-content transition-all duration-200"
                                                @click="confirmSingleDelete(item.path, item.name, 'A')">{{ $tt('删除此文件') }}</button>
                                        </div>
                                    </div>

                                    <!-- 文件B -->
                                    <div class="relative bg-gradient-to-br from-neutral/0 to-neutral/5 p-3 rounded-lg border border-neutral/5 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer" 
                                         @click="toggleFileSelection(item.reason)"
                                         :class="{ 'ring-1 ring-neutral': selectedFiles.includes(item.reason) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedFiles.includes(item.reason)"
                                                @change="toggleFileSelection(item.reason)" class="checkbox checkbox-sm checkbox-neutral">
                                        </div>
                                        <div class="flex items-center mb-2">
                                            <div class="w-8 h-8 bg-neutral rounded-full flex items-center justify-center mr-2 shadow-md">
                                                <i class="fas fa-music text-primary-content text-xs"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-neutral-content text-base mb-0">{{ $tt('文件 B') }}</h4>
                                                <div class="bg-neutral/5 text-neutral-content px-1.5 py-0.5 rounded text-xs font-medium inline-block">{{ $tt('元数据相同') }}</div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-2 rounded-lg mb-2 border border-neutral/30">
                                            <div class="flex items-center mb-1">
                                                <i class="fas fa-folder text-neutral mr-1"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('文件路径') }}</span>
                                            </div>
                                            <div class="text-xs text-base-content font-mono bg-base-200 p-1.5 rounded border truncate" :title="item.reason">
                                                {{ getShortPath(item.reason) }}
                                            </div>
                                        </div>

                                        <div class="space-y-1 mb-3">
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-neutral"></i>{{ $tt('标题') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.title }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-1" v-if="item.extra.b.artist">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-primary"></i>{{ $tt('艺术家') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.artist }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-1" v-if="item.extra.a.album">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-file-audio mr-1 text-primary"></i>{{ $tt('专辑') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.album }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-plus mr-1 text-neutral"></i>{{ $tt('创建时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.created_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-calendar-edit mr-1 text-neutral"></i>{{ $tt('修改时间') }}</span>
                                                <span class="text-xs text-base-content font-medium">{{ item.extra.b.updated_at }}</span>
                                            </div>
                                            <div class="flex items-center justify-between py-0.5">
                                                <span class="text-xs text-base-content/70 flex items-center">
                                                    <i class="fas fa-hdd mr-1 text-neutral"></i>{{ $tt('文件大小') }}</span>
                                                <span class="text-xs text-base-content font-bold bg-neutral/20 px-1.5 py-0.5 rounded">
                                                    {{ (item.extra.b.size / 1024 / 1024).toFixed(2) }} MB
                                                </span>
                                            </div>
                                        </div>

                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-neutral btn-xs btn-outline hover:bg-neutral-500 hover:text-neutral-content transition-all duration-200"
                                                @click="confirmSingleDelete(item.reason, item.name, 'B')">{{ $tt('删除此文件') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 规则删除弹窗 -->
        <dialog id="rule_delete_modal" class="modal">
            <div class="modal-box">
                <h3 class="font-bold text-lg">{{ $tt('智能删除规则设置') }}</h3>
                <div class="py-4">
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text">{{ $tt('删除优先级') }}</span>
                        </label>
                        <multi-select :options="formatList" v-model="ruleForm.formatPriority"></multi-select>
                    </div>
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text">{{ $tt('文件大小规则') }}</span>
                        </label>
                        <single-select v-model="ruleForm.sizeRule" :options="sizeRuleList" :placeholder="$tt('请选择')">
                        </single-select>
                    </div>
                    <!-- <div class="form-control">
                        <label class="label">
                            <span class="label-text">{{ $tt('比特率规则') }}</span>
                        </label>
                        <single-select v-model="ruleForm.bitrateRule" :options="bitRuleList" :placeholder="$tt('请选择')">
                        </single-select>
                    </div>
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text">{{ $tt('采样率/位深规则') }}</span>
                        </label>
                        <single-select v-model="ruleForm.sampleRule" :options="sampleRuleList" :placeholder="$tt('请选择')">
                        </single-select>
                    </div> -->
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text">{{ $tt('文件名规则') }}</span>
                        </label>
                        <single-select v-model="ruleForm.nameRule" :options="nameRuleList" :placeholder="$tt('请选择')">
                        </single-select>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-sm mr-2">{{ $tt('取消') }}</button>
                        <button class="btn btn-primary btn-sm" @click="confirmRuleDelete">{{ $tt('开始智能删除') }}</button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 单个文件删除确认弹窗 -->
        <dialog id="single_delete_modal" class="modal">
            <div class="modal-box">
                <h3 class="font-bold text-lg text-error">
                    <i class="fas fa-exclamation-triangle mr-2"></i>{{ $tt('确认删除文件') }}
                </h3>
                <div class="py-4">
                    <div class="alert alert-warning mb-4">
                        <i class="fas fa-info-circle"></i>
                        <span>{{ $tt('此操作不可撤销，请确认要删除以下文件：') }}</span>
                    </div>
                    <div class="bg-error/10 p-3 rounded-lg border border-error/30">
                        <div class="font-semibold text-error mb-2">
                            {{ deleteConfirm.fileName }} - {{ deleteConfirm.fileLabel }}
                        </div>
                        <div class="text-sm text-base-content break-all">
                            <i class="fas fa-folder mr-1"></i>{{ deleteConfirm.filePath }}
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-sm mr-2">{{ $tt('取消') }}</button>
                        <button class="btn btn-error btn-sm text-primary-content" @click="executeSingleDelete">{{ $tt('确认删除') }}</button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 批量删除确认弹窗 -->
        <dialog id="batch_delete_modal" class="modal">
            <div class="modal-box">
                <h3 class="font-bold text-lg text-error">{{ $tt('确认批量删除') }}</h3>
                <div class="py-4">
                    <div class="alert alert-error mb-4">
                        <i class="fas fa-exclamation-triangle"></i>
                        <span>{{ $tt('您即将删除 {count} 个文件，此操作不可撤销！', { count: selectedFiles.length }) }}</span>
                    </div>
                    <div class="max-h-64 overflow-y-auto">
                        <div v-for="(filePath, index) in selectedFiles" :key="index"
                            class="bg-error/10 p-2 rounded mb-2 border border-error/30">
                            <div class="text-sm text-base-content break-all">
                                {{ getShortPath(filePath) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-sm mr-2">{{ $tt('取消') }}</button>
                        <button class="btn btn-error btn-sm text-primary-content" @click="executeBatchDelete">
                            {{ $tt('确认删除 {count} 个文件', { count: selectedFiles.length }) }}
                        </button>
                    </form>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
import SingleSelect from "@/components/iview/SingleSelect";
import SingleInput from "@/components/iview/SingleInput";
import MultiSelect from "@/components/iview/MultiSelect";
export default {
    name: 'log-detail',
    props: {
        detailData: { type: Object, required: true }
    },
    components: { SingleInput, SingleSelect, MultiSelect },
    data() {
        return {
            id: this.$route.params.id,
            isOpen: true,
            timer: null,
            selectedFiles: [], // 批量选择的文件
            deleteConfirm: { // 单个删除确认信息
                filePath: '',
                fileName: '',
                fileLabel: ''
            },
            batchDeleteMode: '', // 批量删除模式
            ruleForm: {
                sizeRule: 'smaller',
                formatPriority: ['mp3', 'flac'],
                nameRule: 'larger',
                bitrateRule: 'none',
                sampleRule: 'none',
                metadataRule: 'none',
                deleteMode: 'direct',
                targetDir: '',
                mode: ''
            },
            sizeRuleList: [
                { 'id': 'larger', 'name': this.$tt('删除较大文件') },
                { 'id': 'smaller', 'name': this.$tt('删除较小文件') },
                { 'id': 'none', 'name': this.$tt('不判断') },
            ],
            bitRuleList: [
                { 'id': 'larger', 'name': this.$tt('删除较大比特率') },
                { 'id': 'smaller', 'name': this.$tt('删除较小比特率') },
                { 'id': 'none', 'name': this.$tt('不判断') },
            ],
            sampleRuleList: [
                { 'id': 'larger', 'name': this.$tt('删除较大采样率') },
                { 'id': 'smaller', 'name': this.$tt('删除较小采样率') },
                { 'id': 'none', 'name': this.$tt('不判断') },
            ],
            nameRuleList: [
                { 'id': 'larger', 'name': this.$tt('删除含有后缀名') },
                { 'id': 'smaller', 'name': this.$tt('删除不含有后缀名') },
                { 'id': 'none', 'name': this.$tt('不判断') },
            ],
            // 补充所有支持的音频格式，参考后端 constants.py
            formatList: [
                { id: 'flac', name: 'FLAC' },
                { id: 'mp3', name: 'MP3' },
                { id: 'ape', name: 'APE' },
                { id: 'wav', name: 'WAV' },
                { id: 'aiff', name: 'AIFF' },
                { id: 'aif', name: 'AIF' },
                { id: 'wv', name: 'WV' },
                { id: 'tta', name: 'TTA' },
                { id: 'm4a', name: 'M4A' },
                { id: 'ogg', name: 'OGG' },
                { id: 'mpc', name: 'MPC' },
                { id: 'opus', name: 'OPUS' },
                { id: 'wma', name: 'WMA' },
                { id: 'dsf', name: 'DSF' },
                { id: 'dff', name: 'DFF' },
                { id: 'wmv', name: 'WMV' },
                { id: 'dts', name: 'DTS' },
                { id: 'strm', name: 'STRM' }
            ],
        }
    },
    computed: {
        isSuccess() {
            return this.detailData.success.length > 0
        },
        isFail() {
            return this.detailData.fail.length > 0
        },
        isModeSuccess() {
            return this.detailData.mode_success.length > 0
        },
        isMissAA() {
            return this.detailData.miss_artist_album.length > 0
        },
        isMissArtist() {
            return this.detailData.miss_artist.length > 0
        },
        isMissAlbum() {
            return this.detailData.miss_album.length > 0
        },
        isMissTag() {
            return this.detailData.miss_tag.length > 0
        },
        isRunning() {
            return this.detailData.running.length > 0
        },
        isSkip() {
            return this.detailData.skip.length > 0
        },
        isDelete() {
            return this.detailData.delete.length < 1
        },
    },
    mounted() {
        // this.handlePolling()
    },
    beforeDestroy() {
        this.setTimerNull() // 组件销毁前清空定时器
    },
    methods: {
        // 获取文件简短路径用于显示
        getShortPath(fullPath) {
            if (!fullPath) return ''
            const parts = fullPath.split('/')
            if (parts.length > 3) {
                return '.../' + parts.slice(-2).join('/')
            }
            return fullPath
        },

        // 获取文件信息（这里需要根据实际数据结构调整）
        getFileInfo() {
            // 这里应该显示文件大小、格式等信息
            // 目前返回占位信息，实际使用时需要获取真实文件信息
            return this.$tt('文件信息加载中...')
        },

        // 切换文件选择状态
        toggleFileSelection(filePath) {
            const index = this.selectedFiles.indexOf(filePath)
            if (index > -1) {
                this.selectedFiles.splice(index, 1)
            } else {
                this.selectedFiles.push(filePath)
            }
        },

        // 切换批量选择文件A或B
        toggleBatchSelectFiles(mode, fileType) {
            let items = []

            switch (mode) {
                case 'hash':
                    items = this.detailData.mode_success || []
                    break
                case 'name':
                    items = this.detailData.success || []
                    break
                case 'acoustid':
                    items = this.detailData.miss_tag || []
                    break
                case 'metadata':
                    items = this.detailData.fail || []
                    break
            }

            // 获取当前类型的所有文件路径
            const filePaths = items.map(item => fileType === 'A' ? item.path : item.reason)

            // 检查是否已经全部选中
            const allSelected = filePaths.every(path => this.selectedFiles.includes(path))

            if (allSelected) {
                // 如果全部选中，则取消选择
                filePaths.forEach(path => {
                    const index = this.selectedFiles.indexOf(path)
                    if (index > -1) {
                        this.selectedFiles.splice(index, 1)
                    }
                })
            } else {
                // 否则选中所有文件
                filePaths.forEach(path => {
                    if (!this.selectedFiles.includes(path)) {
                        this.selectedFiles.push(path)
                    }
                })
            }
        },

        // 检查文件A是否批量选中
        isBatchSelectedA(mode) {
            let items = []

            switch (mode) {
                case 'hash':
                    items = this.detailData.mode_success || []
                    break
                case 'name':
                    items = this.detailData.success || []
                    break
                case 'acoustid':
                    items = this.detailData.miss_tag || []
                    break
                case 'metadata':
                    items = this.detailData.fail || []
                    break
            }

            const fileAPaths = items.map(item => item.path)
            return fileAPaths.length > 0 && fileAPaths.every(path => this.selectedFiles.includes(path))
        },

        // 检查文件B是否批量选中
        isBatchSelectedB(mode) {
            let items = []

            switch (mode) {
                case 'hash':
                    items = this.detailData.mode_success || []
                    break
                case 'name':
                    items = this.detailData.success || []
                    break
                case 'acoustid':
                    items = this.detailData.miss_tag || []
                    break
                case 'metadata':
                    items = this.detailData.fail || []
                    break
            }

            const fileBPaths = items.map(item => item.reason)
            return fileBPaths.length > 0 && fileBPaths.every(path => this.selectedFiles.includes(path))
        },

        // 获取当前模式下已选中的文件数量
        getBatchSelectedCount(mode) {
            let items = []

            switch (mode) {
                case 'hash':
                    items = this.detailData.mode_success || []
                    break
                case 'name':
                    items = this.detailData.success || []
                    break
                case 'acoustid':
                    items = this.detailData.miss_tag || []
                    break
                case 'metadata':
                    items = this.detailData.fail || []
                    break
            }

            // 获取当前模式下的所有文件路径
            const allPaths = items.flatMap(item => [item.path, item.reason])

            // 计算已选中的文件数量
            return allPaths.filter(path => this.selectedFiles.includes(path)).length
        },

        // 确认单个文件删除
        confirmSingleDelete(filePath, fileName, fileLabel) {
            this.deleteConfirm = {
                filePath: filePath,
                fileName: fileName,
                fileLabel: fileLabel
            }
            document.getElementById('single_delete_modal').showModal()
        },

        // 执行单个文件删除
        executeSingleDelete() {
            this.handleRemoveFile(this.deleteConfirm.filePath, 'single')
            document.getElementById('single_delete_modal').close()
        },

        // 确认批量删除
        confirmBatchDelete() {
            if (this.selectedFiles.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('请先选择要删除的文件'),
                    type: 'warning',
                    time: 2000,
                })
                return
            }
            this.batchDeleteMode = 'single'
            document.getElementById('batch_delete_modal').showModal()
        },

        // 执行批量删除
        executeBatchDelete() {
            if (this.selectedFiles.length === 0) return

            this.handleBatchRemoveFiles(this.selectedFiles, this.batchDeleteMode)
            document.getElementById('batch_delete_modal').close()
        },

        // 智能删除规则设置
        handleRuleDelete(mode) {
            this.ruleForm.mode = mode
            document.getElementById('rule_delete_modal').showModal()
        },

        // 确认规则删除
        confirmRuleDelete() {
            try {
                this.isLoading = true
                this.$api.Task.deleteFiles({
                    log_id: this.id,
                    mode: this.ruleForm.mode,
                    rules: this.ruleForm,
                    paths: []
                }).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.$myMsg.notify({
                            title: this.$tt('智能删除成功！'),
                            type: 'success',
                            time: 2000,
                        })
                        this.$parent.fetchDetails()
                    } else {
                        this.$myMsg.notify({
                            title: this.$tt('智能删除失败！'),
                            content: res.message,
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
                document.getElementById('rule_delete_modal').close()
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },

        // 单个文件删除
        handleRemoveFile(path, mode) {
            try {
                this.isLoading = true
                this.$api.Task.deleteFiles({
                    'log_id': this.id,
                    'paths': [path],
                    'mode': mode
                }).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.$myMsg.notify({
                            title: this.$tt('删除成功！'),
                            type: 'success',
                            time: 2000,
                        })
                        this.$parent.fetchDetails()
                        // 从选中列表中移除已删除的文件
                        const index = this.selectedFiles.indexOf(path)
                        if (index > -1) {
                            this.selectedFiles.splice(index, 1)
                        }
                    } else {
                        this.$myMsg.notify({
                            title: this.$tt('删除失败！'),
                            content: res.message,
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },

        // 批量文件删除
        handleBatchRemoveFiles(paths, mode) {
            try {
                this.isLoading = true
                this.$api.Task.deleteFiles({
                    'log_id': this.id,
                    'paths': paths,
                    'mode': mode
                }).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.$myMsg.notify({
                            title: this.$tt('成功删除 {count} 个文件！', { count: paths.length }),
                            type: 'success',
                            time: 2000,
                        })
                        this.$parent.fetchDetails()
                        // 清空选中列表
                        this.selectedFiles = []
                    } else {
                        this.$myMsg.notify({
                            title: this.$tt('批量删除失败！'),
                            content: res.message,
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },

        // 清空定时器
        setTimerNull() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        }
    }
}
</script>

<style scoped></style>
